import IconClose from "@assets/icons/IconClose";
import IconArrow from "@assets/icons/IconArrow";
import Button from "@components/ui/Button";

const CustomArrayTemplate = ({
  className,
  items,
  canAdd,
  onAddClick,
  idSchema,
  title,
}) => {
  const iconStyle = "cursor-pointer my-0 mx-[5px] w-3.5";
  const oneListItem = items.length <= 1;
  return (
    <div className={className}>
      <legend id={idSchema.$id}>{title}</legend>
      {items &&
        items.map((element) => (
          <div
            key={element.key}
            className={` flex ${`${element.className}`} ${
              oneListItem ? "justify-start" : {}
            }`}
          >
            {element.hasMoveDown && (
              <IconArrow
                iconFillColor="#000"
                className={`${iconStyle} rotate-90`}
                onClick={element.onReorderClick(
                  element.index,
                  element.index + 1
                )}
              />
            )}
            {element.hasMoveUp && (
              <IconArrow
                iconFillColor="#000"
                className={`${iconStyle} rotate-[-90deg]`}
                onClick={element.onReorderClick(
                  element.index,
                  element.index - 1
                )}
              />
            )}
            {element.children}
            {!oneListItem && (
              <div
                className={
                  "hover:after:content-['Remove']  hover:opacity-50 w-0 h-0 hover:after:p-1 hover:after:text-xs hover:after:text-black"
                }
              >
                <IconClose
                  iconFillColor="fill-black"
                  className={iconStyle}
                  onClick={element.onDropIndexClick(element.index)}
                />
              </div>
            )}
          </div>
        ))}
      {canAdd && (
        <div className={oneListItem ? {} : "ml-12"}>
          <Button
            ariaLabel="+ Add Value"
            className="syf-login-action"
            toUpperCase={false}
            componentID="syf-login-action"
            label="+ Add Value"
            height="h-8"
            customStyle={
              "text-white text-sm bg-sky-555 rounded-[4.66px] border-none w-max pt-3 pr-5 inline-flex items-center justify-center !my-1.5 !mx-0"
            }
            theme="secondary"
            key="0"
            onClickCallback={onAddClick}
          />
        </div>
      )}
    </div>
  );
};

export default CustomArrayTemplate;
